<template>

    <dmb-asset
        class="widget-content-image"
        v-if="widget?.settings?.assetId" :style="resolvedStyle"
        :asset-id="widget.settings.assetId"
        :content-mode="widget.settings.contentMode"
        :repeat="widget.settings.repeat" :freeze="freeze"/>

    <div class="widget-content-placeholder" v-else>{{ $t('app.widgets.widgetContentImage.noImage') }}</div>

</template>

<script>

import { Options, Vue } from 'vue-class-component';

import Asset from '../ui/Asset.vue';

export default Options({

    name: 'dmb-widget-content-image',
    props: {
        widget: Object,
        freeze: Boolean
    },
    components: {
        [Asset.name]: Asset
    }
})(
    class WidgetContentImage extends Vue {

        get resolvedStyle(){

            return {

                'width': '100%',
                'height': '100%'
            };
        }
    }
);

</script>